import { filterNonAstNodes } from '../parser';
import { buildExpr } from './expr';
import { buildPattern } from './match';
import { buildName } from './operand';
import { buildStatement, buildUseExpr } from './statement';
import { buildType } from './type';
export const astExprKinds = [
    'operand-expr',
    'unary-expr',
    'binary-expr',
    'closure-expr',
    'list-expr',
    'if-let-expr',
    'while-expr',
    'for-expr',
    'match-expr'
];
export const astDefKinds = ['var-def', 'fn-def', 'trait-def', 'impl-def', 'type-def', 'field-def'];
export const astLiteralKinds = ['string-literal', 'char-literal', 'int-literal', 'float-literal', 'bool-literal'];
export const astInfixOpKinds = [
    'add-op',
    'sub-op',
    'mult-op',
    'div-op',
    'exp-op',
    'mod-op',
    'eq-op',
    'ne-op',
    'ge-op',
    'le-op',
    'gt-op',
    'lt-op',
    'and-op',
    'or-op',
    'assign-op'
];
export const astPostfixOpKinds = [
    'method-call-op',
    'field-access-op',
    'call-op',
    'unwrap-op',
    'bind-op',
    'await-op'
];
export const astKinds = [
    'module',
    'use-expr',
    'variant',
    'return-stmt',
    'break-stmt',
    'call',
    'arg',
    'block',
    'param',
    'type-bounds',
    'fn-type',
    'generic',
    'if-expr',
    'match-clause',
    'pattern',
    'con-pattern',
    'list-pattern',
    'field-pattern',
    'hole',
    'identifier',
    'name',
    'string-interpolated',
    ...astExprKinds,
    ...astDefKinds,
    ...astLiteralKinds,
    ...astInfixOpKinds,
    ...astPostfixOpKinds
];
export const compactAstNode = (node) => {
    if (typeof node !== 'object')
        return node;
    return Object.fromEntries(Object.entries(node)
        .filter(([p]) => p !== 'parseNode')
        .map(([p, v]) => {
        if (Array.isArray(v)) {
            return [p, v.map(compactAstNode)];
        }
        if (typeof v === 'object' && 'parseNode' in v) {
            return [p, compactAstNode(v)];
        }
        return [p, v];
    }));
};
export const buildModuleAst = (node, id, source, mod, compiled = false) => {
    const nodes = filterNonAstNodes(node);
    const useExprs = nodes.filter(n => n.kind === 'use-stmt').map(buildUseExpr);
    const statements = nodes.filter(n => n.kind === 'statement').map(buildStatement);
    const block = { kind: 'block', parseNode: node, statements };
    return {
        kind: 'module',
        parseNode: node,
        source,
        identifier: id,
        mod,
        block,
        scopeStack: [],
        useExprs,
        compiled,
        imports: [],
        relImports: []
    };
};
export const buildParam = (node) => {
    const nodes = filterNonAstNodes(node);
    const pattern = buildPattern(nodes[0]);
    const typeNode = nodes.at(1);
    return { kind: 'param', parseNode: node, pattern, paramType: typeNode ? buildType(typeNode) : undefined };
};
export const buildArg = (node) => {
    const nodes = filterNonAstNodes(node);
    let i = 0;
    const name = nodes[i].kind === 'name' ? buildName(nodes[i++]) : undefined;
    const expr = buildExpr(nodes[i++]);
    return { kind: 'arg', parseNode: node, name, expr };
};
//# sourceMappingURL=index.js.map